module.exports = __webpack_public_path__ + "static/media/tilakqgc.37fd54c3.avif";